import React from 'react';
import { RefreshCw, X, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAppUpdate } from '@/hooks/useAppUpdate';

const UpdatePrompt = () => {
  const { updateAvailable, applyUpdate, forceUpdate } = useAppUpdate();
  const [dismissed, setDismissed] = React.useState(false);
  const [showForce, setShowForce] = React.useState(false);
  
  if (!updateAvailable || dismissed) {
    return null;
  }
  
  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-600 to-orange-600 text-white px-4 py-3 z-[100] shadow-lg">
      <div className="max-w-lg mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="bg-white/20 p-2 rounded-full animate-pulse">
            <RefreshCw className="w-5 h-5" />
          </div>
          <div>
            <p className="font-medium text-sm">Nova versão disponível!</p>
            <p className="text-xs text-blue-100">Toque para atualizar</p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onClick={applyUpdate}
            className="bg-white text-blue-600 hover:bg-blue-50 font-medium"
          >
            Atualizar
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-white/20 rounded"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
      
      {showForce && (
        <div className="max-w-lg mx-auto mt-2 bg-yellow-500/20 rounded-lg p-2 text-xs">
          <p className="flex items-center gap-1">
            <AlertTriangle className="w-3 h-3" />
            Não atualizou? 
            <button onClick={forceUpdate} className="underline font-bold">
              Clique aqui para forçar
            </button>
          </p>
        </div>
      )}
    </div>
  );
};

// Badge compacto para header
export const UpdateBadge = ({ className = '' }) => {
  const { updateAvailable, applyUpdate } = useAppUpdate();
  
  if (!updateAvailable) return null;
  
  return (
    <button
      onClick={applyUpdate}
      className={`flex items-center gap-1 bg-blue-500 text-white text-xs px-2 py-1 rounded-full animate-pulse ${className}`}
    >
      <RefreshCw className="w-3 h-3" />
      Atualizar
    </button>
  );
};

// Botão de forçar atualização (para configurações)
export const ForceUpdateButton = () => {
  const { forceUpdate, currentVersion } = useAppUpdate();
  const [loading, setLoading] = React.useState(false);
  
  const handleForce = async () => {
    setLoading(true);
    await forceUpdate();
  };
  
  return (
    <div className="bg-white rounded-xl p-4 border">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="font-medium text-gray-900">Versão do App</p>
          <p className="text-sm text-gray-500">{currentVersion || 'Carregando...'}</p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleForce}
          disabled={loading}
          className="gap-2"
        >
          <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
          {loading ? 'Atualizando...' : 'Forçar Atualização'}
        </Button>
      </div>
      <p className="text-xs text-gray-400">
        Se o app não estiver funcionando corretamente, force a atualização para limpar o cache.
      </p>
    </div>
  );
};

export default UpdatePrompt;
